export const initialFormValues = {
  accountDescription: '',
  accountNumber: '',
  additionalExpensesValue: '',
  observations: ''
}
